/**
 * @generated SignedSource<<14ef0b30f9e55b45f2f759022e45081f>>
 * @relayHash 000b615cf254734fec99203961fd0137
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 000b615cf254734fec99203961fd0137

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CriticalityLevel = "CRITICAL" | "INFO" | "WARNING";
export type DisplayFor = "CALL_CENTER_AGENT" | "CUSTOMER_SERVICE_CENTER" | "DOCTOR" | "NONE" | "NURSING_PROFESSIONAL";
export type UpdateNewsInput = {
  criticalityLevel: CriticalityLevel;
  displayFor: ReadonlyArray<DisplayFor>;
  endTime?: string | null;
  englishContent: string;
  frenchContent?: string | null;
  germanContent: string;
  id: string;
  italianContent?: string | null;
  startTime: string;
};
export type useUpdateNewsMutation$variables = {
  input: UpdateNewsInput;
};
export type useUpdateNewsMutation$data = {
  readonly updateNews: {
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
    readonly news: {
      readonly id: string;
      readonly isShowing: boolean;
      readonly " $fragmentSpreads": FragmentRefs<"NewsFragment">;
    } | null;
  };
};
export type useUpdateNewsMutation = {
  response: useUpdateNewsMutation$data;
  variables: useUpdateNewsMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isShowing",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUpdateNewsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateNewsPayload",
        "kind": "LinkedField",
        "name": "updateNews",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "News",
            "kind": "LinkedField",
            "name": "news",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "NewsFragment"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUpdateNewsMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "UpdateNewsPayload",
        "kind": "LinkedField",
        "name": "updateNews",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "News",
            "kind": "LinkedField",
            "name": "news",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "criticalityLevel",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "englishContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "germanContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "frenchContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "italianContent",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endTime",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayFor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "000b615cf254734fec99203961fd0137",
    "metadata": {},
    "name": "useUpdateNewsMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "5d9654aa9b0927ad0ae73f4906379f7c";

export default node;
